var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { QuestionnaireHistory } from "../constants/questionnaireHistoryConstants";
import { Status } from "../constants/status";
var initialState = {
    historyState: QuestionnaireHistory.HISTORY,
    numberOfAttempts: 0,
};
function parseAttempts(data) {
    var _a;
    return (_a = data === null || data === void 0 ? void 0 : data.length) !== null && _a !== void 0 ? _a : 0;
}
function shortDate(date) {
    var months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];
    var day = date.getDate().toString().padStart(2, "0");
    var month = months[date.getMonth()];
    var year = date.getFullYear();
    return "".concat(day, " ").concat(month, " ").concat(year);
}
function parseDates(data) {
    return data
        .filter(function (d) { return d.complete && d.completed_at; })
        .sort(function (a, b) { return a.id - b.id; })
        .map(function (d) { return shortDate(new Date(d.completed_at)); });
}
var BarLabels = {
    "General skills score": "General Skill",
    "Job search confidence score": ["Job Search", "Confidence"],
    "Personal attributes score": ["Personal", "Attributes"],
    "Immediacy of employment score": ["Immediacy", "of employment"],
    "Assets score": "Assets",
    "Job-seeking behaviours score": ["Job Seeking", "Behaviours"],
};
var responseMapping = {
    "Strongly disagree": "Not at all",
    "Disagree": "To some extent",
    "Agree": "To a moderate extent",
    "Strongly agree": "To a very great extent",
};
var ASSETS_QUESTION_LABEL = "Tick the following that you possess";
export function parseResponses(data) {
    var _a;
    var parsedData = {};
    var demographics = __assign({}, ((_a = data["Demographics"]) !== null && _a !== void 0 ? _a : {}));
    var assets = {};
    if (ASSETS_QUESTION_LABEL in demographics) {
        assets[ASSETS_QUESTION_LABEL] = demographics[ASSETS_QUESTION_LABEL];
        delete demographics[ASSETS_QUESTION_LABEL];
    }
    parsedData["Demographics"] = demographics;
    parsedData["Assets"] = assets;
    parsedData["Searching for work"] = data["Searching for work"];
    parsedData["General skills"] = data["General skills"];
    parsedData["Job search confidence"] = data["Job search confidence"];
    // remap values in personal attributes
    Object.keys(data["Personal attributes"]).forEach(function (question) {
        var _a;
        var answer = data["Personal attributes"][question];
        data["Personal attributes"][question] = (_a = responseMapping[answer]) !== null && _a !== void 0 ? _a : answer;
    });
    parsedData["Personal attributes"] = data["Personal attributes"];
    parsedData["Qualifications and work history"] = data["Qualifications and work history"];
    parsedData["Health and social support"] = data["Health and social support"];
    parsedData["Personal wellbeing"] = data["Personal wellbeing"];
    parsedData["Proximity to employment"] =
        data["Proximity to employment: self-assessment"];
    parsedData["Overall expectations"] = data["Overall expectations"];
    parsedData["Adviser impact"] = data["Adviser impact"];
    parsedData["Your obligations"] = data["Client obligations data"];
    parsedData["Adviser obligations"] = data["Adviser obligations data"];
    return parsedData;
}
// "Job-seeking behaviours" is the one domain that can come back as `null`
// (when the jobseeker isn't actively seeking employment, per
// strengths.py) rather than a number - unlike every other domain score.
// It should still always appear as a 0 bar rather than being dropped from
// the graph entirely.
var JOB_SEEKING_KEY = "Job-seeking behaviours score";
var JOB_SEEKING_LABEL = BarLabels[JOB_SEEKING_KEY];
function parseGraphData(data) {
    var parsedData = [];
    Object.keys(data.strengths_scores).forEach(function (value) {
        if (typeof data.strengths_scores[value] === "number") {
            var label = BarLabels[value];
            parsedData.push({
                label: label,
                score: data.strengths_scores[value],
            });
        }
    });
    if (!parsedData.some(function (item) { return item.label === JOB_SEEKING_LABEL; })) {
        parsedData.push({
            label: JOB_SEEKING_LABEL,
            score: data.strengths_scores[JOB_SEEKING_KEY] || 0,
        });
    }
    return parsedData;
}
var parseEmpScore = function (data) {
    var parsedData = [];
    parsedData.push({
        label: "Your Score",
        score: data.employability_score,
    });
    console.log("Parsed emp data: ", parsedData);
    return parsedData;
};
var questionnaireHistoryReducer = function (state, action) {
    var _a, _b, _c;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case QuestionnaireHistory.HISTORY:
            return __assign(__assign({}, state), { children: undefined, status: Status.Loading });
        case QuestionnaireHistory.HISTORY_SUCESSFUL:
            return __assign(__assign({}, state), { numberOfAttempts: parseAttempts(action.payload), complete: (_b = (_a = action.payload[0]) === null || _a === void 0 ? void 0 : _a.complete) !== null && _b !== void 0 ? _b : 0, completedDates: parseDates(action.payload), status: Status.Successful });
        case QuestionnaireHistory.RESPONSE_HISTORY_1_SUCESSFUL: {
            var graphDataPayload = ((_c = action.payload) === null || _c === void 0 ? void 0 : _c.strengths_scores_old) &&
                Object.keys(action.payload.strengths_scores_old).length > 0
                ? { strengths_scores: action.payload.strengths_scores_old }
                : action.payload;
            var graphData_1 = parseGraphData(graphDataPayload);
            if (typeof action.payload.wellbeing_score_q1 === "number") {
                graphData_1 = __spreadArray(__spreadArray([], graphData_1, true), [
                    { label: "Personal Wellbeing", score: action.payload.wellbeing_score_q1 },
                ], false);
            }
            return __assign(__assign({}, state), { responses: parseResponses(action.payload), graphData: graphData_1, score: parseEmpScore(action.payload), status: Status.Successful });
        }
        case QuestionnaireHistory.RESPONSE_HISTORY_MILESTONE_SUCESSFUL:
        case QuestionnaireHistory.RESPONSE_HISTORY_2_SUCESSFUL:
            var graphData = parseGraphData(action.payload);
            if (typeof action.payload.wellbeing_score_q2 === "number") {
                graphData = __spreadArray(__spreadArray([], graphData, true), [
                    { label: "Personal Wellbeing", score: action.payload.wellbeing_score_q2 },
                ], false);
            }
            return __assign(__assign({}, state), { responses: parseResponses(action.payload), graphData: graphData, score: parseEmpScore(action.payload), status: Status.Successful });
        case QuestionnaireHistory.PERSONAL_WELLBEING_HISTORY_SUCCESSFUL:
            return __assign(__assign({}, state), { responses: parseResponses(action.payload), graphData: parseGraphData(action.payload), score: parseEmpScore(action.payload), status: Status.Successful });
        default:
            return state;
    }
};
export default questionnaireHistoryReducer;
